import index from '../../images/emaily/index.png';
import create from '../../images/emaily/create.png';
import createSurvey from '../../images/emaily/createSurvey.png';
import dashboard from '../../images/emaily/dashboard.png';
import sendSurvey from '../../images/emaily/sendSurvey.png';

export const EmailyImg = [index, create, createSurvey, dashboard, sendSurvey]